import axios from 'axios'
import Store from '../store'

export const authServiceBaseUrl = 'http://43.229.15.128:8081/'
export const commonServiceBaseUrl = 'http://43.229.15.128:8082/'
export const bazarMonitoringServiceBaseUrl = 'http://43.229.15.128:8083/'
export const teaGardenServiceBaseUrl = 'http://43.229.15.128:8084/'
export const eBizServiceBaseUrl = 'http://43.229.15.128:8085/'
export const bftiPolicyServiceBaseUrl = 'http://43.229.15.128:8086/'
export const licenseRegistrationServiceBaseUrl = 'http://43.229.15.128:8087/'
export const tradeTariffServiceBaseUrl = 'http://43.229.15.128:8088/'
export const internationalTradeFairServiceBaseUrl = 'http://43.229.15.128:8089/'
export const exportTrophyCIPServiceBaseUrl = 'http://43.229.15.128:8090/'
export const rjscServiceBaseUrl = 'http://43.229.15.128:8091/'
export const bftiResReportServiceBaseUrl = 'http://43.229.15.128:8092/'
export const trainingElearningServiceBaseUrl = 'http://43.229.15.128:8093/'

// export const authServiceBaseUrl = 'http://moc-auth-service.local/'
// export const commonServiceBaseUrl = 'http://moc-common-service.local/'
// export const bazarMonitoringServiceBaseUrl = 'http://moc-bazar-monitoring-service.local/'
// export const eBizServiceBaseUrl = 'http://moc-e-biz-management-service.local/'
// export const teaGardenServiceBaseUrl = 'http://moc-tea-garden-service.local/'
// export const bftiPolicyServiceBaseUrl = 'http://moc-bfti-policy-service.local/'
// export const licenseRegistrationServiceBaseUrl = 'http://moc-license-registration-service.local/'
// export const tradeTariffServiceBaseUrl = 'http://moc-trade-tariff-service.local/'
// export const internationalTradeFairServiceBaseUrl = 'http://moc-international-trade-fair-service.local/'
// export const exportTrophyCIPServiceBaseUrl = 'http://moc-trophy-cip-service.local/'
// export const rjscServiceBaseUrl = 'http://moc-rjsc-service.local/'
// export const bftiResReportServiceBaseUrl = 'http://moc-bfti-research-report-management-service.local/'
// export const trainingServiceBaseUrl = 'http://moc-training-service.local/'
// export const trainingElearningServiceBaseUrl = 'http://moc-training-service.local/'

// Handling server error
const errorHandler = (error) => {
  if (error.response === undefined) {
    return error
  } else if (error.response.status === 401) {
    localStorage.clear()
    Store.dispatch('Auth/updateAuthUser', null)
    Store.commit('mutateCommonProperties', {
      hasDropdownLoaded: false
    })
    window.vm.$toast.error({
      title: 'Error',
      message: 'Unauthorized access.'
    })
    window.vm.$router.push('/auth/login')
  } else if (error.response.status === 500) {
    Store.commit('mutateCommonProperties', {
      loading: false,
      listReload: false
    })
  } else {
    window.vm.$toast.error({
      title: 'Error',
      message: 'Operation failed due to an unknown error.'
    })
  }
  return error
}
export default {
  async execute (baseUrl, method, uri, data, params = {}, pdf = false) {
    const accessToken = Store.state.Auth.accessToken
    const userDetail = localStorage.getItem('userDetail')
    let client = []
    if (pdf) {
      client = axios.create({
        baseURL: baseUrl,
        responseType: 'blob'
      })
    } else {
      client = axios.create({
        baseURL: baseUrl,
        json: true
      })
    }

    client.interceptors.response.use(response => response, error => errorHandler(error))
    return client({
      method,
      url: uri,
      data,
      params: params,
      headers: {
        authorization: accessToken ? `Bearer ${accessToken}` : '',
        'user-detail': userDetail ? `${userDetail}` : '',
        'access-menu-name': window.location.href
      }
    }).then(req => {
      return req.data
    })
  },
  getData (baseUrl, uri, params = {}) {
    // const filters = setFilters()
    return this.execute(baseUrl, 'get', uri, {}, params)
  },
  getPdfData (baseUrl, uri, params = {}) {
    // const filters = setFilters()
    return this.execute(baseUrl, 'get', uri, {}, params, true)
  },
  postData (baseUrl, uri, data) {
    return this.execute(baseUrl, 'post', uri, data)
  },
  putData (baseUrl, uri, data) {
    return this.execute(baseUrl, 'put', uri, data)
  },
  deleteData (baseUrl, uri) {
    return this.execute(baseUrl, 'delete', uri)
  }
}
